"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHost = exports.getImageRouteFromUrl = void 0;

var getImageRouteFromUrl = function getImageRouteFromUrl(src) {
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/v';
  var i = src && src.split(split);
  if (i && i[1]) return "v".concat(i[1]);
  throw Error('We not receive the url image in image route from url');
};

exports.getImageRouteFromUrl = getImageRouteFromUrl;

var getHost = function getHost(url) {
  if (url) {
    var host = url.split('/');
    return host[2];
  }

  throw Error('We not receive the url image in get host');
};

exports.getHost = getHost;